import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

import type { ButtonWithLoadingProps } from './ButtonWithLoading';
import { ButtonWithLoading } from './ButtonWithLoading';

export const ButtonSave = forwardRef<HTMLButtonElement, ButtonWithLoadingProps>(
	function ButtonSaveRender(props, ref) {
		const { t } = useTranslation('common');

		return (
			<ButtonWithLoading
				color="primary"
				variant="contained"
				{...props}
				data-testid="button-save"
				ref={ref}
			>
				{props.children || t('buttons.save')}
			</ButtonWithLoading>
		);
	}
);
